import axios from "axios"

async function getTariffs() {
    return axios({
        method: "GET",
        url: `/api/v1/tariffs`,
    })
}

async function getTariffsLog() {
    return axios({
        method: "GET",
        url: `/api/v1/tariffs-logs`,
    })
}

async function getTariffsLogByDateAndWorkspace(data:any) {
    function query() {
        const {start_date, end_date} = data;
        if (!data.start_date && !data.end_date) return "";
        let query = "?";
        if (start_date) query = query + "start_date=" + start_date + "&";
        if (end_date) query = query + "end_date=" + end_date + "&";
        return query.slice(0, query.length - 1)
    }
    return axios({
        method: "GET",
        url: `/api/v1/workspaces/${data.uuid}/tariffs-logs${query()}`,
    })
}

async function getTariffsLogByDate(data:any) {
    function query() {
        const {start_date, end_date} = data;
        if (!data.start_date && !data.end_date) return "";
        let query = "?";
        if (start_date) query = query + "start_date=" + start_date + "&";
        if (end_date) query = query + "end_date=" + end_date + "&";
        return query.slice(0, query.length - 1)
    }
    return axios({
        method: "GET",
        url: `/api/v1/tariffs-logs-by-date${query()}`,
    })
}

async function getTariffsLogDetails(uuid:string) {
    return axios({
        method: "GET",
        url: `/api/v1/tariffs-logs/${uuid}`,
    })
}

async function patchTariffsLog(uuid:string) {
    return axios({
        method: "PATCH",
        url: `/api/v1/tariffs-logs/${uuid}`,
    })
}

export {
    getTariffs,
    getTariffsLog,
    getTariffsLogDetails,
    patchTariffsLog,
    getTariffsLogByDateAndWorkspace,
    getTariffsLogByDate
}